import * as actions from './actions'
import mutations from './mutations'
import * as getters from './getters'

const Store = {
  state: {
    stores: [],
    store: null,
    statusStores: null
  },
  getters,
  mutations,
  actions
}

export default Store
